import { combineReducers } from 'redux';

import alertReducer from './alert/alert.slice';
import alertSettingsUserReducer from './alert_settings_user/alert_settings_user.slice';
import chatReducer from './chat/chat.slice';
import classificationClassReducer from './classification_class/classification_class.slice';
import classificationSubgroupReducer from './classification_subgroup/classification_subgroup.slice';
import clientReducer from './client/client.slice';
import connectionReducer from './connection/connection.slice';
import consumerUnitReducer from './consumer_unit/consumer_unit.slice';
import currentFlagReducer from './current_flag/current_flag.slice';
import establishmentReducer from './establishment/establishment.slice';
import filterConsumerUnitReducer from './filter_consumer_unit/filter_consumer_unit.slice';
import invitationReducer from './invitation/invitation.slice';
import invoiceReducer from './invoice/invoice.slice';
import loadProfileReducer from './load_profile/load_profile.slice';
import loadingReducer from './loading/loading.slice';
import modalInvoiceReducer from './modal_invoice/modal_invoice.slice';
import monitoringSystemReducer from './monitoring_system/monitoring_system.slice';
import monitoringSystemUserReducer from './monitoring_system_user/monitoring_system_user.slice';
import planReducer from './plan/plan.slice';
import plantApiReducer from './plant_api/plant_api.slice';
import stateReducer from './state/state.slice';
import userReducer from './user/user.slice';
import utilityCompanyReducer from './utility_company/utility_company.slice';
import voltageReducer from './voltage/voltage.slice';
import creditReducer from './credit/credit.slice';

import { azimuthApi } from 'api/azimuth.api';
import { dashboardApi } from 'api/dashboard.api';
import { monthGenerationApi } from 'api/monthGeneration.api';
import { solarOportunityApi } from 'api/solarOportunity.api';
import { tiltApi } from 'api/tilt.api';

export const reducers = combineReducers({
  alert: alertReducer,
  alertSettingsUser: alertSettingsUserReducer,
  chat: chatReducer,
  classificationClass: classificationClassReducer,
  classificationSubgroup: classificationSubgroupReducer,
  client: clientReducer,
  connection: connectionReducer,
  consumerUnit: consumerUnitReducer,
  currentFlag: currentFlagReducer,
  establishment: establishmentReducer,
  filterConsumerUnit: filterConsumerUnitReducer,
  invitation: invitationReducer,
  invoice: invoiceReducer,
  loading: loadingReducer,
  loadProfile: loadProfileReducer,
  modalInvoice: modalInvoiceReducer,
  monitoringSystem: monitoringSystemReducer,
  monitoringSystemUser: monitoringSystemUserReducer,
  plan: planReducer,
  plantApi: plantApiReducer,
  state: stateReducer,
  user: userReducer,
  utilityCompany: utilityCompanyReducer,
  voltage: voltageReducer,
  credit: creditReducer,
  [azimuthApi.reducerPath]: azimuthApi.reducer,
  [monthGenerationApi.reducerPath]: monthGenerationApi.reducer,
  [solarOportunityApi.reducerPath]: solarOportunityApi.reducer,
  [tiltApi.reducerPath]: tiltApi.reducer,
  [dashboardApi.reducerPath]: dashboardApi.reducer,
});
